import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cart-widget__overview__table" }

import {
  ref,
  computed,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { formatNumber } from '@/helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartOverview',
  props: {
  buttonDisabled: Boolean,
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit;


const router = useRouter();
const store = useStore();
const isOrderPage = computed(() => store.getters['page/pageType'] === 'order');
const root = ref<InstanceType<typeof HTMLElement>>();

const totalPerMonth = computed(() => formatNumber(store.getters['cart/commodityPerMonth'], 2));
const totalPerYear = computed(() => formatNumber(store.getters['cart/commodityPerYear'], 2));

const gotoOrder = () => {
  if (!isOrderPage.value) {
    router.push('/bestellung/adresse/');
    emit('close');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "cart-widget__overview",
    ref_key: "root",
    ref: root
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("th", null, " Gesamt pro Monat ", -1)),
          _createElementVNode("td", null, _toDisplayString(totalPerMonth.value) + " € ", 1)
        ]),
        _createElementVNode("tr", null, [
          _cache[1] || (_cache[1] = _createElementVNode("th", null, " Gesamt pro Jahr ", -1)),
          _createElementVNode("td", null, _toDisplayString(totalPerYear.value) + " € ", 1)
        ])
      ]),
      (!__props.buttonDisabled)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["cart-widget__overview__entry", { 'inactive': isOrderPage.value }]),
            onClick: gotoOrder
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("button", { class: "btn btn-sm btn-outline-white w-100" }, " Zur Kasse ", -1)
          ]), 2))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})